import { axios } from 'apis';
import { Sale } from 'models';

const ENDPOINT = 'Sales';
export const SalesService = {
	getAll: async (): Promise<Sale[]> => {
		const response = await axios.get(`${ENDPOINT}`);
		return await response.data;
	},
	getAllForUser: async (): Promise<Sale[]> => {
		const response = await axios.get(`${ENDPOINT}/GetAllForUser`);
		return await response.data;
	},
	update: async (sale: Sale) => {
		await axios.put(`${ENDPOINT}`, sale);
	},
	create: async (sale: Sale) => {
		await axios.post(`${ENDPOINT}`, sale);
	},
	delete: async (id: number) => {
		await axios.delete(`${ENDPOINT}/${id}`);
	},
};